<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="MX532, MX632, XM3350 MFP'leri">
     MX532, MX632, XM3350 MFP'leri
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_tr" title="G&uuml;venlik bilgileri">
     G&uuml;venlik bilgileri
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Kurallar">
      Kurallar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e40" title="&Uuml;r&uuml;n beyanları">
      &Uuml;r&uuml;n beyanları
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_tr" title="Yazıcıyı tanıma">
     Yazıcıyı tanıma
    </a>
   </p>
   <div id="divd0e175">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_tr" title="Yazıcı hakkında bilgi bulma">
      Yazıcı hakkında bilgi bulma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_tr" title="Yazıcı seri numarasını bulma">
      Yazıcı seri numarasını bulma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_tr" title="Yazıcı yapılandırmaları">
      Yazıcı yapılandırmaları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_tr" title="Kontrol panelini kullanma">
      Kontrol panelini kullanma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_tr" title="G&ouml;sterge ışığının durumunu anlama">
      G&ouml;sterge ışığının durumunu anlama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-paper-group.html#d0e500" title="Kağıt se&ccedil;me">
      Kağıt se&ccedil;me
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_tr" title="Kurma, y&uuml;kleme ve yapılandırma">
     Kurma, y&uuml;kleme ve yapılandırma
    </a>
   </p>
   <div id="divd0e1569">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_tr" title="Yazıcı i&ccedil;in bir yer se&ccedil;me">
      Yazıcı i&ccedil;in bir yer se&ccedil;me
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_tr" title="Kabloları takma">
      Kabloları takma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#d0e1764" title="Ana ekran uygulamalarını ayarlama ve kullanma">
      Ana ekran uygulamalarını ayarlama ve kullanma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e2411" title="Erişilebilirlik &ouml;zelliklerini kurma ve kullanma">
      Erişilebilirlik &ouml;zelliklerini kurma ve kullanma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e2717" title="Yazıcıyı faks g&ouml;ndermek i&ccedil;in ayarlama">
      Yazıcıyı faks g&ouml;ndermek i&ccedil;in ayarlama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_tr" title="E-posta SMTP ayarlarını yapılandırma">
      E-posta SMTP ayarlarını yapılandırma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#d0e4576" title="Kağıt ve &ouml;zel ortam y&uuml;kleme">
      Kağıt ve &ouml;zel ortam y&uuml;kleme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e4742" title="Yazılımı, s&uuml;r&uuml;c&uuml;leri ve bellenimi kurma ve g&uuml;ncelleme">
      Yazılımı, s&uuml;r&uuml;c&uuml;leri ve bellenimi kurma ve g&uuml;ncelleme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e5023" title="Donanım se&ccedil;eneklerini kurma">
      Donanım se&ccedil;eneklerini kurma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="wireless-support-topic.html#d0e5332" title="Ağ">
      Ağ
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_tr" title="Yazıcıyı g&uuml;venceye alma">
     Yazıcıyı g&uuml;venceye alma
    </a>
   </p>
   <div id="divd0e5757">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_tr" title="G&uuml;venlik yuvasını bulma">
      G&uuml;venlik yuvasını bulma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_tr" title="Yazıcı belleğini silme">
      Yazıcı belleğini silme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_tr" title="Yazıcı depolama s&uuml;r&uuml;c&uuml;s&uuml;n&uuml; silme">
      Yazıcı depolama s&uuml;r&uuml;c&uuml;s&uuml;n&uuml; silme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_tr" title="&Uuml;retici varsayılan ayarlarını geri y&uuml;kleme">
      &Uuml;retici varsayılan ayarlarını geri y&uuml;kleme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_tr" title="Ge&ccedil;icilik Bildirimi">
      Ge&ccedil;icilik Bildirimi
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_tr" title="Yazdırma">
     Yazdırma
    </a>
   </p>
   <div id="divd0e5950">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_tr" title="Bilgisayardan yazdırma">
      Bilgisayardan yazdırma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e5976" title="Mobil aygıttan yazdırma">
      Mobil aygıttan yazdırma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_tr" title="Bir flaş s&uuml;r&uuml;c&uuml;den yazdırma">
      Bir flaş s&uuml;r&uuml;c&uuml;den yazdırma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_tr" title="Desteklenen flash s&uuml;r&uuml;c&uuml;ler ve dosya t&uuml;rleri">
      Desteklenen flash s&uuml;r&uuml;c&uuml;ler ve dosya t&uuml;rleri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_tr" title="Gizli işlerin yapılandırılması">
      Gizli işlerin yapılandırılması
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_tr" title="Gizli ve diğer bekletilen işleri yazdırma">
      Gizli ve diğer bekletilen işleri yazdırma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_tr" title="yazı tipi &ouml;rneği listesi yazdırma">
      yazı tipi &ouml;rneği listesi yazdırma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_tr" title="Bir dizin listesi yazdırma">
      Bir dizin listesi yazdırma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_tr" title="Kopyalar arasına ayırma sayfaları yerleştirme">
      Kopyalar arasına ayırma sayfaları yerleştirme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_tr" title="Bir yazdırma işini iptal etme">
      Bir yazdırma işini iptal etme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_tr" title="Toner koyuluğunu ayarlama">
      Toner koyuluğunu ayarlama
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_tr" title="Kopyalama">
     Kopyalama
    </a>
   </p>
   <div id="divd0e6566">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_tr" title="Otomatik belge besleyicisi ve tarayıcı camını kullanarak">
      Otomatik belge besleyicisi ve tarayıcı camını kullanarak
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_tr" title="Fotokopi &ccedil;ekme">
      Fotokopi &ccedil;ekme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_tr" title="Fotoğraf kopyalama">
      Fotoğraf kopyalama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_tr" title="Antetli kağıda kopyalama">
      Antetli kağıda kopyalama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_tr" title="Kağıdın her iki tarafına kopyalama">
      Kağıdın her iki tarafına kopyalama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_tr" title="Kopyaları k&uuml;&ccedil;&uuml;ltme veya b&uuml;y&uuml;tme">
      Kopyaları k&uuml;&ccedil;&uuml;ltme veya b&uuml;y&uuml;tme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_tr" title="Kopyaları harmanlama">
      Kopyaları harmanlama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_tr" title="Kopyalar arasına ayırma sayfaları yerleştirme">
      Kopyalar arasına ayırma sayfaları yerleştirme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_tr" title="Bir kağıda birden fazla sayfa kopyalama">
      Bir kağıda birden fazla sayfa kopyalama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_tr" title="Kartları kopyalama">
      Kartları kopyalama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_tr" title="Kopyalama kısayolu oluşturma">
      Kopyalama kısayolu oluşturma
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_tr" title="E-posta">
     E-posta
    </a>
   </p>
   <div id="divd0e6877">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_tr" title="Otomatik belge besleyicisi ve tarayıcı camını kullanarak">
      Otomatik belge besleyicisi ve tarayıcı camını kullanarak
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_tr" title="E-posta g&ouml;nderme">
      E-posta g&ouml;nderme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_tr" title="Bir e-posta kısayolu oluşturma">
      Bir e-posta kısayolu oluşturma
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_tr" title="Faks">
     Faks
    </a>
   </p>
   <div id="divd0e6971">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_tr" title="Otomatik belge besleyicisi ve tarayıcı camını kullanarak">
      Otomatik belge besleyicisi ve tarayıcı camını kullanarak
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_tr" title="Faks g&ouml;nderme">
      Faks g&ouml;nderme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_tr" title="Faks programlama">
      Faks programlama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_tr" title="Faks hedefi kısayolu oluşturma">
      Faks hedefi kısayolu oluşturma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_tr" title="Faks &ccedil;&ouml;z&uuml;n&uuml;rl&uuml;ğ&uuml;n&uuml; değiştirme">
      Faks &ccedil;&ouml;z&uuml;n&uuml;rl&uuml;ğ&uuml;n&uuml; değiştirme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_tr" title="Faks koyuluğunun ayarlanması">
      Faks koyuluğunun ayarlanması
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_tr" title="Faks g&uuml;nl&uuml;ğ&uuml; yazdırma">
      Faks g&uuml;nl&uuml;ğ&uuml; yazdırma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_tr" title="İstenmeyen faksları engelleme">
      İstenmeyen faksları engelleme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_tr" title="Faks bekletme">
      Faks bekletme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_tr" title="Faks iletme">
      Faks iletme
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_tr" title="Tarama">
     Tarama
    </a>
   </p>
   <div id="divd0e7336">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_tr" title="Otomatik belge besleyicisi ve tarayıcı camını kullanarak">
      Otomatik belge besleyicisi ve tarayıcı camını kullanarak
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_tr" title="Bilgisayara tarama">
      Bilgisayara tarama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_tr" title="Bir FTP sunucusuna tarama">
      Bir FTP sunucusuna tarama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_tr" title="FTP kısayolu oluşturma">
      FTP kısayolu oluşturma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="s2a-scanning-to-network-folders-topic.html#s2a-scanning-to-network-folders_tr" title="Ağ klas&ouml;r&uuml;ne tarama">
      Ağ klas&ouml;r&uuml;ne tarama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_tr" title="Ağ klas&ouml;r&uuml; kısayolu oluşturma">
      Ağ klas&ouml;r&uuml; kısayolu oluşturma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_tr" title="Flaş s&uuml;r&uuml;c&uuml;ye tarama">
      Flaş s&uuml;r&uuml;c&uuml;ye tarama
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_tr" title="Yazıcı men&uuml;lerini kullanma">
     Yazıcı men&uuml;lerini kullanma
    </a>
   </p>
   <div id="divd0e7639">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menu-map-mfp_tr" title="Men&uuml; haritası">
      Men&uuml; haritası
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e8020" title="Aygıt">
      Aygıt
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e10354" title="Yazdırma">
      Yazdırma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e11517" title="Kağıt">
      Kağıt
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e11877" title="Kopyalama">
      Kopyalama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e12449" title="Faks">
      Faks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e14877" title="E-posta">
      E-posta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e15893" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e16539" title="USB S&uuml;r&uuml;c&uuml;s&uuml;">
      USB S&uuml;r&uuml;c&uuml;s&uuml;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e17340" title="Ağlar/Portlar">
      Ağlar/Portlar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e19484" title="G&uuml;venlik">
      G&uuml;venlik
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e20634" title="Bulut Hizmetleri">
      Bulut Hizmetleri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e20691" title="Raporlar">
      Raporlar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_tr" title="Sorun Giderme">
      Sorun Giderme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_tr" title="Form Birleştirme">
      Form Birleştirme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_tr" title="Men&uuml; Ayarları Sayfasını yazdırma">
      Men&uuml; Ayarları Sayfasını yazdırma
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_tr" title="Yazıcının bakımını yapma">
     Yazıcının bakımını yapma
    </a>
   </p>
   <div id="divd0e21235">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_tr" title="Par&ccedil;aların ve sarf malzemelerinin durumunu kontrol etme">
      Par&ccedil;aların ve sarf malzemelerinin durumunu kontrol etme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_tr" title="Sarf malzemesi bildirimlerini yapılandırma">
      Sarf malzemesi bildirimlerini yapılandırma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_tr" title="E-posta uyarılarını ayarlama">
      E-posta uyarılarını ayarlama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_tr" title="Raporları g&ouml;r&uuml;nt&uuml;leme">
      Raporları g&ouml;r&uuml;nt&uuml;leme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_tr" title="Par&ccedil;a ve sarf malzemeleri sipariş etme">
      Par&ccedil;a ve sarf malzemeleri sipariş etme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e21568" title="Par&ccedil;a ve sarf malzemelerini değiştirme">
      Par&ccedil;a ve sarf malzemelerini değiştirme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e21911" title="Yazıcı par&ccedil;alarını temizleme">
      Yazıcı par&ccedil;alarını temizleme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e22058" title="Enerji ve kağıt tasarrufu">
      Enerji ve kağıt tasarrufu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_tr" title="Yazıcıyı başka bir yere taşıma">
      Yazıcıyı başka bir yere taşıma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_tr" title="Yazıcıyı uzak bir yere taşıma">
      Yazıcıyı uzak bir yere taşıma
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_tr" title="Sorun giderme">
     Sorun giderme
    </a>
   </p>
   <div id="divd0e22212">
    <p class="toc-2-style">
     <a href="print-quality-problems-picker-topic.html#print-quality-problems-picker_tr" title="Yazdırma kalitesi sorunları">
      Yazdırma kalitesi sorunları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_tr" title="Yazıcı hata kodları">
      Yazıcı hata kodları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_tr" title="Yazdırma sorunları">
      Yazdırma sorunları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_tr" title="Yazıcı yanıt vermiyor">
      Yazıcı yanıt vermiyor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_tr" title="Flaş s&uuml;r&uuml;c&uuml; okunamıyor">
      Flaş s&uuml;r&uuml;c&uuml; okunamıyor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_tr" title="USB bağlantı noktasını etkinleştirme">
      USB bağlantı noktasını etkinleştirme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_tr" title="Sıkışmaları giderme">
      Sıkışmaları giderme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e25883" title="Ağ bağlantısı sorunları">
      Ağ bağlantısı sorunları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e26111" title="Donanım se&ccedil;enekleri sorunları">
      Donanım se&ccedil;enekleri sorunları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e26259" title="Sarf malzemeleriyle ilgili sorunlar">
      Sarf malzemeleriyle ilgili sorunlar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e26382" title="Kağıt besleme sorunları">
      Kağıt besleme sorunları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e26748" title="E-posta sorunları">
      E-posta sorunları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e26842" title="Faks sorunları">
      Faks sorunları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e27487" title="Tarama sorunları">
      Tarama sorunları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_tr" title="M&uuml;şteri destek merkezine başvurma">
      M&uuml;şteri destek merkezine başvurma
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_tr" title="Geri d&ouml;n&uuml;ş&uuml;m ve imha">
     Geri d&ouml;n&uuml;ş&uuml;m ve imha
    </a>
   </p>
   <div id="divd0e28266">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_tr" title="Lexmark &uuml;r&uuml;nlerini geri d&ouml;n&uuml;şt&uuml;rme">
      Lexmark &uuml;r&uuml;nlerini geri d&ouml;n&uuml;şt&uuml;rme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_tr" title="Lexmark ambalajının geri d&ouml;n&uuml;ş&uuml;m&uuml;">
      Lexmark ambalajının geri d&ouml;n&uuml;ş&uuml;m&uuml;
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_tr" title="Bildirimler">
     Bildirimler
    </a>
   </p>
   <div id="divd0e28303">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28306" title="&Uuml;r&uuml;n bilgileri">
      &Uuml;r&uuml;n bilgileri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28323" title="S&uuml;r&uuml;m bildirimi">
      S&uuml;r&uuml;m bildirimi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_tr" title="Ticari markalar">
      Ticari markalar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_tr" title="Lisans uyarıları">
      Lisans uyarıları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_tr" title="Ses emisyon seviyeleri">
      Ses emisyon seviyeleri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_tr" title="Atık Elektrik ve Elektronik Cihazlar (WEEE) direktifi">
      Atık Elektrik ve Elektronik Cihazlar (WEEE) direktifi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28429" title="Lityum iyon şarj edilebilir pil">
      Lityum iyon şarj edilebilir pil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_tr" title="Y&ouml;netmelik (AB) 2023/1542">
      Y&ouml;netmelik (AB) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28467" title="WEEE (Turkey)">
      WEEE (Turkey)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28472" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_tr" title="&Uuml;r&uuml;n&uuml; elden &ccedil;ıkarma">
      &Uuml;r&uuml;n&uuml; elden &ccedil;ıkarma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_tr" title="Yeniden kullanım veya geri d&ouml;n&uuml;ş&uuml;m i&ccedil;in Lexmark kartuşlarını iade etme">
      Yeniden kullanım veya geri d&ouml;n&uuml;ş&uuml;m i&ccedil;in Lexmark kartuşlarını iade etme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_tr" title="Statik elektriğe duyarlılık uyarısı">
      Statik elektriğe duyarlılık uyarısı
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_tr" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_tr" title="Sıcaklık bilgileri">
      Sıcaklık bilgileri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_tr" title="Lazer uyarısı">
      Lazer uyarısı
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_tr" title="Enerji t&uuml;ketimi">
      Enerji t&uuml;ketimi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_tr" title="Telekom&uuml;nikasyon terminal ekipmanı i&ccedil;in d&uuml;zenleyici bildirimler">
      Telekom&uuml;nikasyon terminal ekipmanı i&ccedil;in d&uuml;zenleyici bildirimler
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28736" title="Kablosuz &uuml;r&uuml;nler i&ccedil;in d&uuml;zenleyici bildirimler">
      Kablosuz &uuml;r&uuml;nler i&ccedil;in d&uuml;zenleyici bildirimler
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_tr" title="Mod&uuml;ler bileşen bildirimi">
      Mod&uuml;ler bileşen bildirimi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_tr" title="Radyo frekans radyasyonuna maruz kalma">
      Radyo frekans radyasyonuna maruz kalma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28761" title="Avrupa Topluluğu (AT) y&ouml;nergelerine uygunluk">
      Avrupa Topluluğu (AT) y&ouml;nergelerine uygunluk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_tr" title="Avrupa Topluluğu (AT) y&ouml;nergelerine uygunluk">
      Avrupa Topluluğu (AT) y&ouml;nergelerine uygunluk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_tr" title="Radyo paraziti uyarısı">
      Radyo paraziti uyarısı
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue